import { Button, Grid, Modal, Typography } from "@mui/material";

export interface ConfirmModalProps {
  title: string;
  message: string;
  open: boolean;

  onConfirm: () => void;
  onCancel: () => void;

  loading?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
};

export const ConfirmModal = (props: ConfirmModalProps) => {
  return (
    <Modal
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={props.open}
      onClose={props.onCancel}
    >
      <Grid
        container
        spacing={4}
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: 2,
          padding: 3,
          minWidth: 400,
          boxShadow: 24,
          outline: 'none',
        })}
      >
        <Grid size={12}>
          <Typography color="textPrimary" variant="h6">
            {props.title}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Typography color="textPrimary">
            {props.message}
          </Typography>
        </Grid>

        {/* Action Buttons */}
        <Grid
          container
          size={12}
          justifyContent="flex-end"
          spacing={2}
          sx={{ mt: 2 }}
        >
          <Grid>
            <Button
              variant="contained"
              color="error"
              onClick={props.onCancel}
              loading={props.loading}
            >
              {props.cancelButtonText ?? 'No'}
            </Button>
          </Grid>

          <Grid>
            <Button
              variant="contained"
              onClick={props.onConfirm}
              loading={props.loading}
            >
              {props.confirmButtonText ?? 'Yes'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );

}